import React from 'react';
import NavigationActionCreator from 'action_creators/navigation';
import ModalActionCreator from 'action_creators/modal';
import CheckoutPersonal from 'views/plugins/checkout/personal';
import PaymentMethods from 'views/plugins/tours/page/booking_details/payment_methods';
import { t } from 'services/translation';
import { triggerCheckoutStepScroll } from 'views/plugins/checkout/utils/scroll_utils';
import CheckoutHeader from '../header';
import Cover from '../cover';
import Submit from '../submit';
import { trackCheckoutMobileArriveOnPage } from '../segmentTracking';

class CheckoutPersonalScreen extends React.Component {
  static displayName = 'CheckoutPersonalScreen';

  componentDidMount() {
    triggerCheckoutStepScroll();
    const {
      flags,
      booking_request_id: bookingRequestId,
      fields,
      tour_id: tourId,
      tour,
    } = this.props;

    trackCheckoutMobileArriveOnPage({
      flags,
      bookingRequestId: bookingRequestId || fields?.get('id'),
      tourId,
      guideId: tour?.guide_id,
      guideName: tour?.guide_name,
      pageName: 'Checkout Personal Details',
    });
    this._sendGoogleTagManagerEvents();
  }

  componentDidUpdate(prevProps, prevState) {
    const { fromSummary } = this.props;
    if (this._hasSaved(prevProps)) {
      NavigationActionCreator.transitionTo(this._nextScreen(), {
        fromSummary,
      });
    }
  }

  componentWillUnmount() {
    ModalActionCreator.hide();
  }

  _sendGoogleTagManagerEvents = () => {
    const {
      tour,
      tour_id,
      unitPrice,
      total,
      currency,
      guests,
      is_ga4_enabled,
      unitPriceForInitialPricing,
      totalWithoutServiceFee,
      units_and_addons_detail,
    } = this.props;
    const { name } = tour;
    try {
      const bookingDetails = {
        tour_id,
        tour_name: name,
        unit_price: unitPrice,
        total_price: total.toString(),
        currency: currency.toUpperCase(),
        guests,
        is_ga4_enabled,
        unit_price_for_initial_pricing: unitPriceForInitialPricing,
        total_without_service_fee: totalWithoutServiceFee,
        units_and_addons_detail: units_and_addons_detail.toJS(),
      };

      window.googleTagManagerAddToCart(bookingDetails);
      window.googleTagManagerCheckout(bookingDetails, 1);
    } catch (error) {
      console.log('google tag error', error);
    }
  };

  _googleTagManagerCheckoutProgress = (step) => {
    const {
      tour,
      tour_id,
      unitPrice,
      total,
      currency,
      guests,
      is_ga4_enabled,
      unitPriceForInitialPricing,
      totalWithoutServiceFee,
      units_and_addons_detail,
    } = this.props;
    const { name } = tour;
    try {
      const bookingDetails = {
        tour_id,
        tour_name: name,
        unit_price: unitPrice,
        total_price: total,
        currency: currency.toUpperCase(),
        guests,
        is_ga4_enabled,
        unit_price_for_initial_pricing: unitPriceForInitialPricing,
        total_without_service_fee: totalWithoutServiceFee,
        units_and_addons_detail: units_and_addons_detail.toJS(),
      };
      window.googleTagManagerCheckout(bookingDetails, step);
    } catch (error) {
      console.log('google tag error', error);
    }
  };

  _shouldSkipPayment = () => {
    return this.props.priceProps.zero_priced_tour || this.props.paid_in_cash;
  };

  _nextScreen = () => {
    if (this.props.shouldCollectGuestInfo) {
      return 'Views.Plugins.Checkout.Mobile.Screens.GuestInformation';
    }
    if (this._shouldSkipPayment()) {
      if (this.props.shouldShowAdditionalInformation) {
        return 'Views.Plugins.Checkout.Mobile.Screens.AdditionalInformation';
      }
      return 'Views.Plugins.Checkout.Mobile.Screens.CheckoutSummary';
    }
    return 'Views.Plugins.Checkout.Mobile.Screens.CheckoutPayment';
  };

  _hasSaved = (prevProps) => {
    return this.props.saved === true && prevProps.saved === false;
  };

  _submitLabel = () => {
    let label = null;
    const baseLabel = `${t('NEXT')}: `;
    if (this.props.shouldCollectGuestInfo) {
      label = `${baseLabel} ${t('GUEST_INFORMATION')}`;
    } else if (this._shouldSkipPayment()) {
      if (this.props.shouldShowAdditionalInformation) {
        label = `${baseLabel} ${t('ADDITIONAL_INFORMATION')}`;
      } else {
        label = `${baseLabel} ${t('REVIEW_DETAILS')}`;
      }
    } else {
      label = `${baseLabel} ${t('PAYMENT_DETAILS')}`;
    }
    return label;
  };

  _paymentMethodsComponent = () => {
    const bookingRequest = {
      id: this.props.booking_request_id,
      tour_id: this.props.tour_id,
    };
    return (
      <PaymentMethods
        bookingRequest={bookingRequest}
        onlineTotal={this.props.priceProps.onlineTotal}
        cashTotal={this.props.priceProps.cashTotal}
        loading={this.props.loading}
      />
    );
  };

  _submitClicked = (e) => {
    e.preventDefault();
    if (this.props.can_be_paid_in_cash) {
      ModalActionCreator.show({
        content: this._paymentMethodsComponent(),
        settings: { closable: true },
      });
    } else {
      this.props.onSubmit(e);
    }
  };

  _showBack = () => {
    return !this.props.forInvoice && !this.props.is_booking_invoice;
  };

  _coverProps = () => {
    return {
      forInvoice: this.props.forInvoice,
      tourPicture: this.props.tour.picture,
      guideAvatar: this.props.tour.guide_avatar,
      tourName: this.props.tour.name_translation,
      guideName: this.props.tour.guide_name,
      hasResource: this.props.has_resource,
      resourceName: this.props.resource_name,
    };
  };

  render() {
    const { timer } = this.props;
    return (
      <div className="CheckoutPersonalScreen">
        <CheckoutHeader
          showBack={this._showBack()}
          priceProps={this.props.priceProps}
        />
        <article className="transition-ctx">
          <Cover {...this._coverProps()} />
          {timer}
          <div className="BookingRequest-form ui form">
            <CheckoutPersonal
              {...this.props}
              googleTagManagerCheckoutProgress={
                this._googleTagManagerCheckoutProgress
              }
            />
            <Submit
              label={this._submitLabel()}
              onSubmit={this._submitClicked}
              dataTestProp="mobile-checkout-submit"
            />
          </div>
        </article>
      </div>
    );
  }
}

export default CheckoutPersonalScreen;
